import VideoSectionPage from '../components/VideoSectionPage';

export default function EnseignementsPage() {
  return (
    <VideoSectionPage
      section="enseignements"
      sidebarLabel="NOS ENSEIGNEMENTS PAR ANNÉE"
      renderKey="byYear"
      videoTitlePrefix={null}
      showThemeFilter={true}
      multipleVideosPerDay={true}
    />
  );
}
